import styled from 'styled-components';
import { PlayerNameWrapper, PlayerMatchupWrapper, PlayerDataWrapper, PlayerStatsWrapper } from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.style';

export const SavePlaceHolder = styled.div`
    width: 62px;
`;
export const PlayerDecisionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    ${PlayerMatchupWrapper} {
        margin-right: 5px;

        &:hover {
            > div:last-child > div:first-child > div {
                border-bottom: 0;
            }
        }
    }
    ${PlayerNameWrapper} {
        a {
            color: var(--gameday-primary-font-color);
        }
    }
    ${PlayerDataWrapper} {
        ${({ isLoading }) => isLoading ? `
            >div {
                &:first-child {
                    >div {
                        height: 20px;
                        width: 70px;
                    }
                }
                &:last-child {
                    >div {
                        height: 10px;
                        width: 60px;
                    }
                }
            }
        ` : ''}
    }
    ${PlayerStatsWrapper} {
        color: var(--gameday-secondary-font-color);
        >span {
            margin: 0px 8px;
        }
    }
    font-family: var(--gameday-primary-font);
`;
